/* eslint-disable */
export default function (Vue) {
  Vue.ga = {
    setToken (allowed, expiration) {
      localStorage.setItem('analytics', allowed);
      localStorage.setItem('expirationGa', expiration);
    },
    getToken () {
      let token = localStorage.getItem('analytics');

      let expiration = localStorage.getItem('expirationGa');

      // console.log(expiration, token)
      if (!token || !expiration) return false;
      if (Date.now() > parseInt(expiration)) {
        this.destroyToken();
        return null;
      } else return true;
    },
    destroyToken () {
      localStorage.removeItem('analytics');
      localStorage.removeItem('expirationGa');
    },
    hasAnalytics () {
      return this.getToken();
    }
  };
  Object.defineProperties(Vue.prototype, {
    $ga: {
      get () {
        return Vue.ga
      }
    }
  })
}
